import { useQuery } from "@tanstack/react-query";
import {
  fetchRareSkills,
  FetchRareSkillsParams,
  FetchRareSkillsResponse
} from "PFCore/services/skills/fetch_rare_skills";
import { QueryOptions } from "PFCore/types";

import { skillsKeys } from "./query_keys";

export const useRareSkills = (
  params: FetchRareSkillsParams,
  options?: QueryOptions<FetchRareSkillsResponse>
) =>
  useQuery<FetchRareSkillsResponse>({
    queryKey: skillsKeys.rare(params),
    queryFn: () => fetchRareSkills(params),
    ...options
  });
